import styled from "styled-components";

import { RecordText as Base } from "../styled/RecordText";

import { ClassName } from "./settings";

export const RecordTextWithMarks = styled(Base)`
  mark {
    border-radius: 2px;
    padding: 4px 0;

    &.${ClassName.find} {
      background-color: ${({ theme }) => theme.colors["yellow"]};
      transition: background-color .4s;

      &.current {
        background-color:  ${({ theme }) => theme.colors["forest-green"]};
      }
    }

    &.${ClassName.audio} {
      background-color: ${({ theme }) => theme.colors["sp-blue-50"]};
    }
  }
`;
